package antd.layout

import kotlinext.js.jsObject
import react.ComponentType
import react.RBuilder
import react.RHandler

fun RBuilder.layout(handler: RHandler<LayoutProps>) = child(LayoutComponent::class, handler)
fun RBuilder.header(handler: RHandler<LayoutProps>) = child(LayoutComponent.Header as ComponentType<LayoutProps>,jsObject{}, handler)
fun RBuilder.footer(handler: RHandler<LayoutProps>) = child(LayoutComponent.Footer as ComponentType<LayoutProps>,jsObject{}, handler)
fun RBuilder.content(handler: RHandler<LayoutProps>) = child(LayoutComponent.Content as ComponentType<LayoutProps>,jsObject{}, handler)
fun RBuilder.sider(handler: RHandler<SiderProps>) = child(LayoutComponent.Sider as ComponentType<SiderProps>,jsObject{}, handler)
fun RBuilder.space(handler: RHandler<SpaceProps>) = child(Space::class, handler)
